import React from 'react';

const facts = [
  { label: 'Education', value: 'MCA (AI/ML)' },
  { label: 'Focus', value: 'Full Stack' },
  { label: 'Experience', value: '3+ years' },
  { label: 'Status', value: 'Freelancing' },
];

const skills = ['React', 'Next.js', 'TypeScript', 'Node.js', 'Firebase', 'MongoDB', 'Tailwind', 'AWS'];

const About = () => {
  return (
    <section id="about" className="section border-b border-[var(--line)]">
      <div className="wrap grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-20">
        <div>
          <p className="t-kicker mb-4">About</p>
          <h2 className="t-display text-5xl md:text-6xl">
            Products first.<br />
            <em className="italic text-[var(--signal)]">Always.</em>
          </h2>
        </div>

        <div>
          <p className="t-body mb-6 max-w-xl">
            I completed my Bachelor’s in Computer Application and I’m now pursuing my MCA (AI/ML) at Chandigarh University. I specialize in shipping web products that stay in production — not just in a repo.
          </p>
          <p className="t-body mb-10 max-w-xl">
            The through-line is the same: make the messy parts of a business feel calm. Freelancers, cab operators, agencies, and PG owners all get a system they can run every day.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
            {facts.map((fact) => (
              <div key={fact.label} className="rounded-2xl border border-[var(--line)] bg-[var(--bg-2)] p-4">
                <p className="t-kicker mb-2">{fact.label}</p>
                <p className="text-[var(--ink)] font-medium">{fact.value}</p>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-2">
            {skills.map((skill) => (
              <span key={skill} className="chip">{skill}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
